var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRowSpacingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.529,
    height: 18.379,
    viewBox: "0 0 22.529 18.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9575",
    "data-name": "Group 9575",
    transform: "translate(893.245 22860.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27459",
    "data-name": "Path 27459",
    d: "M75.284,5.15h12a1,1,0,1,0,0-2h-12a1,1,0,0,0,0,2",
    transform: "translate(-959 -22861)",
    fill: "#e62e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27460",
    "data-name": "Path 27460",
    d: "M87.284,14.849h-12a1,1,0,0,0,0,2h12a1,1,0,0,0,0-2",
    transform: "translate(-959 -22861)",
    fill: "#e62e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27461",
    "data-name": "Path 27461",
    d: "M87.284,9h-12a1,1,0,0,0,0,2h12a1,1,0,0,0,0-2",
    transform: "translate(-959 -22861)",
    fill: "#e62e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27462",
    "data-name": "Path 27462",
    d: "M70.728,4.857a1,1,0,1,0,1.414-1.414L69.8,1.1a1.014,1.014,0,0,0-.326-.216,1,1,0,0,0-1.089.216l-2.34,2.34a1,1,0,0,0,1.414,1.414l.633-.633V15.776l-.633-.633a1,1,0,0,0-1.414,1.414l2.339,2.34a1,1,0,0,0,1.093.216A1,1,0,0,0,69.8,18.9l2.339-2.34a1,1,0,0,0-1.414-1.414l-.633.633V4.224Z",
    transform: "translate(-959 -22861)",
    fill: "#e62e2e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowSpacingIcon);
export default __webpack_public_path__ + "static/media/RowSpacingIcon.60c14a8fe5364120ecec49ec16a13ba7.svg";
export { ForwardRef as ReactComponent };